import React, { useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import "../../App.css";
import "./Djurplatser.css";
import { setFormErrors } from "../../helpers/util";
import FormElement from "../../components/FormElement/FormElement";
import HiddenToolFields from "../../components/HiddenToolFields";
import ToolHeader from "../../components/ToolHeader/ToolHeader";
import {
  CalculateActionButton,
  SaveResultsActionButton,
} from "../../components/ActionButton/ActionButton";
import useSavedResults from "../../helpers/useSavedResults";
import ActionsBar from "../../components/ActionsBar/ActionsBar";
import FormSection from "../../components/FormSection/FormSection";
import InputColumn from "../../components/InputColumn/InputColumn";
import Wrapper from "../../components/Wrapper/Wrapper";
import ActionButtons from "../../components/ActionButtons/ActionButtons";
import ServerMessages from "../../components/ServerMessages/ServerMessages";

const schema = yup
  .object({
    C3: yup.number().typeError("Endast numeriskt värde tillåtet"), // C3: Antal kalvningar vår
    C4: yup.number().typeError("Endast numeriskt värde tillåtet").nullable(), // C4: Ålder vi avvänjning
    C5: yup.number().typeError("Endast numeriskt värde tillåtet").nullable(), // C5: Ålder vid slakt tjurar
    C6: yup.number().typeError("Endast numeriskt värde tillåtet").nullable(), // C6: Ålder vid slakt kvigor
    C7: yup.number().typeError("Endast numeriskt värde tillåtet").nullable(), // C7: Antal kor som byts ut varje år
    C8: yup.number().typeError("Endast numeriskt värde tillåtet").nullable(), // C8: Antal avelstjurar
    C9: yup.number().typeError("Endast numeriskt värde tillåtet").nullable(), // C9: Kvigans ålder vid inkalvning
  })
  .required();

function Djurplatser() {
  const [serverMessages, setServerMessages] = useState([]);
  const [hasResults, setHasResults] = useState(
    window.wpObject.tool_data != null
  );
  const { displaySavedAlert } = useSavedResults();

  const methods = useForm({
    defaultValues: {
      C3:
        window.wpObject?.tool_data?.data?.C3 != null
          ? window.wpObject?.tool_data?.data?.C3
          : 0, //  C3: Antal kalvningar vår
      C4:
        window.wpObject?.tool_data?.data?.C4 != null
          ? window.wpObject?.tool_data?.data?.C4
          : 0, //  C4: Ålder vi avvänjning
      C5:
        window.wpObject?.tool_data?.data?.C5 != null
          ? window.wpObject?.tool_data?.data?.C5
          : 0, //  C5: Ålder vid slakt tjurar
      C6:
        window.wpObject?.tool_data?.data?.C6 != null
          ? window.wpObject?.tool_data?.data?.C6
          : 0, //  C6: Ålder vid slakt kvigor
      C7:
        window.wpObject?.tool_data?.data?.C7 != null
          ? window.wpObject?.tool_data?.data?.C7
          : 0, //  C7: Antal kor som byts ut varje år
      C8:
        window.wpObject?.tool_data?.data?.C8 != null
          ? window.wpObject?.tool_data?.data?.C8
          : 0, //  C8: Antal avelstjurar
      C9:
        window.wpObject?.tool_data?.data?.C9 != null
          ? window.wpObject?.tool_data?.data?.C9
          : 0, //  C9: Kvigans ålder vid inkalvning
    },
    resolver: yupResolver(schema),
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = methods;

  const form = useRef(null);

  const [result, setResult] = useState({
    // results are thought of as number of places {property}
    C12:
      window.wpObject?.tool_data?.data?.C12 != null
        ? window.wpObject?.tool_data?.data?.C12
        : 0, // C12: Antal stallplatser dikor
    C13:
      window.wpObject?.tool_data?.data?.C13 != null
        ? window.wpObject?.tool_data?.data?.C13
        : 0, // C13: Antal platser avelstjurar
    C14:
      window.wpObject?.tool_data?.data?.C14 != null
        ? window.wpObject?.tool_data?.data?.C14
        : 0, // C14: Antal platser tjurar 6 - 18 månader	 30 djur		Första vintern - under betesperioden är stallet tomt
    C15:
      window.wpObject?.tool_data?.data?.C15 != null
        ? window.wpObject?.tool_data?.data?.C15
        : 0, // C15: Antal platser kvigor 6 - 18 månader	 30 djur		Första vintern - under betesperioden är stallet tomt
    C16:
      window.wpObject?.tool_data?.data?.C16 != null
        ? window.wpObject?.tool_data?.data?.C16
        : 0, // C16: Antal platser slakttjurar 18 - 30 månader	 30 djur		Andra vintern och eventuellt sommaren om slaktdjuren inte går på bete
    C17:
      window.wpObject?.tool_data?.data?.C17 != null
        ? window.wpObject?.tool_data?.data?.C17
        : 0, // C17: Antal platser kvigor 18 - 30 månader	 30 djur		Andra vintern - under betespreioden är stallet tomt
    C18:
      window.wpObject?.tool_data?.data?.C18 != null
        ? window.wpObject?.tool_data?.data?.C18
        : 0, // C18: Antal platser slakttjurar 30 - 42 månader	 0 djur		Tredje vintern och eventuellt sommaren om slaktdjuren inte går på bete
    C19:
      window.wpObject?.tool_data?.data?.C19 != null
        ? window.wpObject?.tool_data?.data?.C19
        : 0, // C19: Antal platser kvigor 30 - 42 månader	 0 djur		Tredje vintern - under betespreioden är stallet tomt
    C20:
      window.wpObject?.tool_data?.data?.C20 != null
        ? window.wpObject?.tool_data?.data?.C20
        : 0, // C20: Antal platser rekrytering 30 - 42 månader	 7 djur		Tredje vintern om rekryteringskvigan blir äldre än 2 år vid inkalvning
    C24:
      window.wpObject?.tool_data?.data?.C24 != null
        ? window.wpObject?.tool_data?.data?.C24
        : 0, // C24: Antal platser för kalvning - lagkrav	 6 platser		Enskilt eller i grupp
    C25:
      window.wpObject?.tool_data?.data?.C25 != null
        ? window.wpObject?.tool_data?.data?.C25
        : 0, // C25: Antal platser för behandling av sjuka djur - lagkrav	 8 platser		Enskilt eller i grupp
    C22:
      window.wpObject?.tool_data?.data?.C22 != null
        ? window.wpObject?.tool_data?.data?.C22
        : 0, // C22: Summa djurplatser
  });

  const handleCalculate = (formData) => {
    setServerMessages([]);

    if (window?.wpObject?.ajax_url == null) {
      return;
    }

    const requestData = new FormData(form.current);
    requestData.append("action", "wt_ajax_tools_djurplatser");

    fetch(window.wpObject.ajax_url, {
      method: "POST",
      body: requestData,
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.success) {
          setResult(response.data);
          setHasResults(true);
        } else {
          if ("errorsItemized" in response.data) {
            setFormErrors(response.data.errorsItemized, methods);
          }
          if ("errors" in response.data) {
            setServerMessages(response.data.errors.map((e) => e));
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSaveResults = async () => {
    if (window?.wpObject?.ajax_url == null) {
      return;
    }
    const requestData = new FormData(form.current);
    Object.keys(result)
      .filter((cell) => !requestData.has(cell))
      .map((rCell) => requestData.append(rCell, result[rCell]));
    requestData.append("action", "wt_ajax_save_results_djurplatser");

    fetch(window.wpObject.ajax_url, {
      method: "POST",
      body: requestData,
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.success) {
          if (window?.wpObject?.saved_results_url != null) {
            displaySavedAlert();
          } else {
            setServerMessages([response.data.message]);
          }
        } else {
          if ("errorsItemized" in response.data) {
            setFormErrors(response.data.errorsItemized, methods);
          }
          if ("errors" in response.data) {
            setServerMessages(response.data.errors.map((e) => e));
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="tool-base">
      <ToolHeader />
      <ActionsBar
        hasResults={hasResults}
        onSave={handleSubmit(handleSaveResults)}
        serverMessages={serverMessages}
        onCalculate={handleSubmit(handleCalculate)}
      />

      <FormSection className="tool">
        <Wrapper>
          <form ref={form} onSubmit={handleSubmit(handleCalculate)}>
            <HiddenToolFields />

            <h4>Vårkalvning</h4>
            <h6>2 månaders kalvningsperiod</h6>
            <InputColumn className="input-column">
              <div className="left-column">
                <FormElement
                  label="Antal kalvningar vår"
                  id="C3"
                  unit="kalvningar"
                  tooltip="Antal kalvning både kor och kvigor"
                  register={register}
                  errors={errors?.C3}
                />

                <FormElement
                  label="Ålder vi avvänjning"
                  id="C4"
                  unit="månader"
                  tooltip="Avvänjning innan installning av dikor på hösten"
                  register={register}
                  errors={errors?.C4}
                />

                <FormElement
                  label="Ålder vid slakt tjurar"
                  id="C5"
                  unit="månader"
                  register={register}
                  errors={errors?.C5}
                />

                <FormElement
                  label="Ålder vid slakt kvigor"
                  id="C6"
                  unit="månader"
                  register={register}
                  errors={errors?.C6}
                />

                <FormElement
                  label="Antal kor som byts ut varje år"
                  id="C7"
                  unit="dikor"
                  register={register}
                  errors={errors?.C7}
                />

                <FormElement
                  label="Antal avelstjurar"
                  id="C8"
                  unit="tjurar"
                  register={register}
                  errors={errors?.C8}
                />

                <FormElement
                  label="Kvigans ålder vid inkalvning"
                  id="C9"
                  unit="månader"
                  register={register}
                  errors={errors?.C9}
                />

                <ActionButtons className="actionButtonsBar">
                  <CalculateActionButton
                    onClick={handleSubmit(handleCalculate)}
                  />
                  <SaveResultsActionButton
                    disabled={hasResults}
                    onClick={handleSubmit(handleSaveResults)}
                  />
                  <ServerMessages serverMessages={serverMessages} />
                </ActionButtons>
              </div>

              <div className="right-column">
                <div>
                  <FormElement
                    label="Antal platser"
                    id="C12"
                    unit="dikor"
                    value={result?.C12 != null ? result.C12 : 0}
                    disabled
                    register={register}
                    errors={errors?.C12}
                  />

                  <FormElement
                    label="Antal platser avelstjurar"
                    id="C13"
                    unit="tjurar"
                    value={result?.C13 != null ? result.C13 : 0}
                    disabled
                    register={register}
                    errors={errors?.C13}
                  />

                  <FormElement
                    label="Antal platser tjurar 6 - 18 månader"
                    id="C14"
                    unit="djur"
                    value={result?.C14 != null ? result.C14 : 0}
                    disabled
                    register={register}
                    errors={errors?.C14}
                    tooltip="Första vintern - under betesperioden är stallet tomt"
                  />

                  <FormElement
                    label="Antal platser kvigor 6 - 18 månader"
                    id="C15"
                    unit="djur"
                    value={result?.C15 != null ? result.C15 : 0}
                    disabled
                    register={register}
                    errors={errors?.C15}
                    tooltip="Första vintern - under betesperioden är stallet tomt"
                  />

                  <FormElement
                    label="Antal platser slakttjurar 18 - 30 månader"
                    id="C16"
                    unit="djur"
                    value={result?.C16 != null ? result.C16 : 0}
                    disabled
                    register={register}
                    errors={errors?.C16}
                    tooltip="Andra vintern och eventuellt sommaren om slaktdjuren inte går på bete"
                  />

                  <FormElement
                    label="Antal platser kvigor 18 - 30 månader"
                    id="C17"
                    unit="djur"
                    value={result?.C17 != null ? result.C17 : 0}
                    disabled
                    register={register}
                    errors={errors?.C17}
                    tooltip="Andra vintern - under betespreioden är stallet tomt"
                  />

                  <FormElement
                    label="Antal platser slakttjurar 30 - 42 månader"
                    id="C18"
                    unit="djur"
                    value={result?.C18 != null ? result.C18 : 0}
                    disabled
                    register={register}
                    errors={errors?.C18}
                    tooltip="Tredje vintern och eventuellt sommaren om slaktdjuren inte går på bete"
                  />

                  <FormElement
                    label="Antal platser kvigor 30 - 42 månader"
                    id="C19"
                    unit="djur"
                    value={result?.C19 != null ? result.C19 : 0}
                    disabled
                    register={register}
                    errors={errors?.C19}
                    tooltip="Tredje vintern - under betespreioden är stallet tomt"
                  />

                  <FormElement
                    label="Antal platser rekrytering 30 - 42 månader"
                    id="C20"
                    unit="djur"
                    value={result?.C20 != null ? result.C20 : 0}
                    disabled
                    register={register}
                    errors={errors?.C20}
                    tooltip="Tredje vintern om rekryteringskvigan blir äldre än 2 år vid inkalvning"
                  />

                  {/* <Divider /> ---------------------------- */}
                  <hr />

                  <FormElement
                    transparent
                    label="Summa djurplatser"
                    unit="djur"
                    value={result?.C22 != null ? result.C22 : 0}
                    disabled
                  />

                  <FormElement
                    label="Antal platser för kalvning - se djurskyddsbestämmelser"
                    unit="platser"
                    value={result?.C24 != null ? result.C24 : 0}
                    disabled
                    tooltip="Enskilt eller i grupp"
                  />
                  <FormElement
                    label="Antal platser för behandling av sjuka djur - se djurskyddsbestämmelser"
                    unit="platser"
                    value={result?.C25 != null ? result.C25 : 0}
                    disabled
                    tooltip="Enskilt eller i grupp"
                  />
                </div>
              </div>
            </InputColumn>
          </form>
        </Wrapper>
      </FormSection>

      <ActionsBar
        hasResults={hasResults}
        onSave={handleSubmit(handleSaveResults)}
        serverMessages={serverMessages}
        onCalculate={handleSubmit(handleCalculate)}
      />
    </div>
  );
}

export default Djurplatser;
